import React, { Component } from 'react';
import couterpart from 'counterpart';

import {MdDeleteForever} from 'react-icons/md';

import WorkOrderDataService from '../services/WorkOrderDataService';
import ImageViewer from './ImageViewer';
import UploaderWorkOrderImage from './UploaderWorkOrderImage';
import AuthenticationService from '../services/AuthenticationService';
import {
  IMAGE_TYPE_FRONT,
  IMAGE_TYPE_BACK,
  BLANK_IMG
} from '../constants';
import { ICON_COLOR } from '../icon';

class WorkOrderImages extends Component {
  constructor () {
    super();
    this.state = {
      frontImage: null,
      backImage: null,
      selectedFileNames: ""
    };
    this.handleFileSelectionChange = this.handleFileSelectionChange.bind(this);
  }

  componentDidMount () {
    WorkOrderDataService.retrieveImagesOfWorkOrder(this.props.workOrderId).then(data => {
      if (data.length > 0){
        if (data[0].imageType === IMAGE_TYPE_FRONT){
          this.setState({ frontImage:  data[0]});
        }else{
          this.setState({ backImage:  data[0]});
        }
      }

      if (data.length > 1){
        if (data[1].imageType === IMAGE_TYPE_FRONT){
          this.setState({ frontImage:  data[1]});
        }else{
          this.setState({ backImage:  data[1]});
        }
      }
    });
  }

  handleUpdate(){
    WorkOrderDataService.retrieveImagesOfWorkOrder(this.props.workOrderId).then(data => {
      this.setState({ frontImage:  null, backImage: null });
      if (data.length > 0){
        if (data[0].imageType === IMAGE_TYPE_FRONT){
          this.setState({ frontImage:  data[0]});
        }else{
          this.setState({ backImage:  data[0]});
        }
      }

      if (data.length > 1){
        if (data[1].imageType === IMAGE_TYPE_FRONT){
          this.setState({ frontImage:  data[1]});
        }else{
          this.setState({ backImage:  data[1]});
        }
      }    
      this.setState({ updated: true});
    });
  }

  handlDeleteImage(iid){
    WorkOrderDataService.deleteImage(iid).then(data => {
      this.handleUpdate();
    });
  }  

  renderUpload(imageType){
    if (!AuthenticationService.isDesigner()){
      return (<></>);
    }
    let fId = 0;
    if (imageType === 2){
      fId = this.state.backImage? this.state.backImage.id : 0;
    } else if (imageType === 1){
      fId = this.state.frontImage? this.state.frontImage.id : 0;
    }

    return (
      <>
        <button className="myButton" type="button" onClick={(e) => this.handlDeleteImage(fId)}>
          <MdDeleteForever color={ICON_COLOR}/>
                        </button>
        <UploaderWorkOrderImage mode={this.props.mode} 
          workOrderId={this.props.workOrderId} 
          imageType={imageType}
          handleUpdate={this.handleUpdate.bind(this)}
          onFileChanged={this.handleFileSelectionChange} />
          <br/>
      </>
      );
  }

  handleFileSelectionChange(fileName){
    this.setState({ selectedFileNames:  fileName});
  }

  render() {
    if (this.props.listMode == 1){
      let fimage = this.state.frontImage? this.state.frontImage.content: undefined;
      let bimage = this.state.backImage? this.state.backImage.content: undefined;

       if (fimage === undefined && bimage === undefined){
        return (
          <>
          </>
        );
      }

      if (fimage !== undefined && bimage !== undefined){
        return (
          <>
            <img src={`data:image/jpeg;base64,${fimage}`} width="50" height="50"/>
            <img src={`data:image/jpeg;base64,${bimage}`} width="50" height="50"/>
          </>
        );
      }

      if (fimage !== undefined && bimage === undefined){
        return (
          <>
            <img src={`data:image/jpeg;base64,${fimage}`} width="50" height="50"/>
          </>
        );
      }

      if (fimage === undefined && bimage !== undefined){
        return (
          <>
            <img src={`data:image/jpeg;base64,${bimage}`} width="50" height="50"/>
          </>
        );
      }      
    }
    if (this.props.largeMode === 1){
      return (
        <div className="col-12">
          <div className="row">
            <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
              <b>{couterpart.translate('work_order_image_face')}</b>
            </div>          
            <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
              <ImageViewer width={350} largeMode={1} 
                    height={200} 
                    data={this.state.frontImage? this.state.frontImage.content: BLANK_IMG}
                    filename={this.state.frontImage? this.state.frontImage.name: ""}/>
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
              <b>{couterpart.translate('work_order_image_back')}</b>
            </div>
            <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
              <ImageViewer width={250}  largeMode={1}
                    height={200} 
                    data={this.state.backImage? this.state.backImage.content: BLANK_IMG}
                    filename={this.state.backImage? this.state.backImage.name: ""}/>
            </div>
          </div>
          <div className="row">{this.state.selectedFileNames}</div> 
        </div>     
      ); 
    } 
    return (
      <>
        <div className="row">
          <div className="col-4 border-right border-light-gray">
            <b>{couterpart.translate('work_order_image_face')}</b>
            { this.renderUpload(IMAGE_TYPE_FRONT) }
          </div>
          <div className="col-8 border-top border-left border-right border-bottom border-light-gray">
            <ImageViewer width={250} 
                  height={200} 
                  data={this.state.frontImage? this.state.frontImage.content: ""}
                  filename={this.state.frontImage? this.state.frontImage.name: ""}/>
          </div>
        </div>
        <div className="row">
          <div className="col-4 col-2 border-top border-left border-right border-bottom border-light-gray">
            <b>{couterpart.translate('work_order_image_back')}</b>
            { this.renderUpload(IMAGE_TYPE_BACK) }
          </div>
          <div className="col-8 border-top border-left border-right border-bottom border-light-gray">
            <ImageViewer width={250} 
                  height={200} 
                  data={this.state.backImage? this.state.backImage.content: ""}
                  filename={this.state.backImage? this.state.backImage.name: ""}/>
          </div>
        </div>
        <div className="row">{this.state.selectedFileNames}</div> 
      </>     
    );    
  }
}

export default WorkOrderImages;